(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["forge-questionnaire"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class ForgeIntake extends HTMLElement {
      connectedCallback() {
        if (!this.querySelector('[data-step]')) return;
        this.form = this.querySelector('form');
        this.panels = Array.from(this.querySelectorAll('[data-step]'));
        this.current = 0;
        this.progressBar = this.querySelector('[data-progress-bar]');
        this.progressPercent = this.querySelector('[data-progress-percent]');
        this.progressLabel = this.querySelector('[data-progress-label]');
        this.summary = this.querySelector('[data-summary]');
        this.querySelectorAll('[data-next]').forEach((button) => button.addEventListener('click', () => this.next()));
        this.querySelectorAll('[data-back]').forEach((button) => button.addEventListener('click', () => this.back()));
        this.form.addEventListener('change', (event) => this.handleChange(event));
        this.form.addEventListener('input', (event) => this.handleInput(event));
        this.form.addEventListener('submit', (event) => this.handleSubmit(event));
        this.updateConditions();
        this.updateProgress();
      }

      next() {
        if (!this.validatePanel(this.panels[this.current])) return;
        if (this.current < this.panels.length - 1) this.show(this.current + 1);
      }

      back() {
        if (this.current > 0) this.show(this.current - 1);
      }

      show(index) {
        this.panels[this.current].classList.remove('is-active');
        this.panels[this.current].setAttribute('aria-hidden', 'true');
        this.current = index;
        const panel = this.panels[this.current];
        panel.classList.add('is-active');
        panel.removeAttribute('aria-hidden');
        this.updateProgress();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const heading = panel.querySelector('h1, h2');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          window.setTimeout(() => heading.focus({ preventScroll: true }), 220);
        }
      }

      updateProgress() {
        const completed = Math.max(0, this.current - 1);
        const percent = Math.round((completed / (this.panels.length - 1)) * 100);
        this.progressBar.style.width = `${percent}%`;
        this.progressPercent.textContent = `${percent}%`;
        const name = this.panels[this.current].dataset.stageName;
        if (name) this.progressLabel.textContent = name;
        this.querySelectorAll('[data-stage-dot]').forEach((dot) => {
          const stage = Number(dot.dataset.stageDot);
          dot.classList.toggle('is-current', stage === this.current);
          dot.classList.toggle('is-done', stage < this.current);
        });
      }

      validatePanel(panel) {
        let valid = true;
        const required = Array.from(panel.querySelectorAll('[required]')).filter((field) => !field.closest('[hidden]'));
        required.forEach((field) => {
          if (!field.checkValidity()) {
            valid = false;
            field.reportValidity();
          }
        });
        panel.querySelectorAll('[data-min-checks]').forEach((group) => {
          const minimum = Number(group.dataset.minChecks || 1);
          const checked = group.querySelectorAll('input[type="checkbox"]:checked').length;
          const error = group.parentElement.querySelector('[data-group-error]');
          if (error) error.classList.toggle('is-visible', checked < minimum);
          if (checked < minimum) valid = false;
        });
        if (!valid) {
          const firstInvalid = panel.querySelector(':invalid, [data-group-error].is-visible');
          if (firstInvalid) firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return valid;
      }

      handleChange(event) {
        if (event.target.matches('[data-exclusive]') && event.target.checked) {
          event.target.closest('[data-health-list]').querySelectorAll('input:not([data-exclusive])').forEach((input) => { input.checked = false; });
        } else if (event.target.closest('[data-health-list]') && !event.target.matches('[data-exclusive]') && event.target.checked) {
          const exclusive = event.target.closest('[data-health-list]').querySelector('[data-exclusive]');
          if (exclusive) exclusive.checked = false;
        }
        this.updateConditions();
      }

      handleInput(event) {
        if (event.target.matches('[data-range]')) event.target.nextElementSibling.textContent = event.target.value;
        if (event.target.matches('[data-confidence]')) this.querySelector('[data-confidence-output]').textContent = event.target.value;
      }

      updateConditions() {
        const healthList = this.querySelector('[data-health-list]');
        const healthDetails = this.querySelector('[data-health-details]');
        if (healthList && healthDetails) {
          const flagged = healthList.querySelectorAll('input:not([data-exclusive]):checked').length > 0;
          healthDetails.hidden = !flagged;
          healthDetails.querySelectorAll('input, textarea, select').forEach((field) => { field.disabled = !flagged; });
        }

        this.querySelectorAll('[data-condition]').forEach((element) => {
          const [name, allowedString] = element.dataset.condition.split(':');
          const allowed = allowedString.split('|');
          const candidates = Array.from(this.form.querySelectorAll(`[name="contact[${name}]"]`));
          const selected = candidates.find((field) => {
            if (field.type === 'radio' || field.type === 'checkbox') return field.checked;
            return true;
          });
          const insideHiddenHealthBranch = Boolean(element.closest('[data-health-details][hidden]'));
          const insideHiddenCondition = Boolean(element.parentElement && element.parentElement.closest('[data-condition][hidden]'));
          const show = !insideHiddenHealthBranch && !insideHiddenCondition && Boolean(selected && allowed.includes(selected.value));
          element.hidden = !show;
          element.querySelectorAll('input, textarea, select').forEach((field) => { field.disabled = !show; });
        });
      }

      buildTrackerPayload(data) {
        const get = (name) => String(data.get(`contact[${name}]`) || '').trim();
        const selected = (items) => items
          .filter(([name]) => get(name) === 'Yes')
          .map(([, label]) => label)
          .join(', ');
        const healthFlags = selected([
          ['health_heart_condition', 'Heart condition'],
          ['health_chest_pain', 'Chest pain'],
          ['health_dizziness_fainting', 'Dizziness or fainting'],
          ['health_bone_joint_neuro', 'Bone, joint or neurological issue'],
          ['health_recent_surgery', 'Recent surgery'],
          ['health_pregnancy_postpartum', 'Pregnancy or postpartum'],
          ['health_medication', 'Medication affecting exercise'],
          ['health_other_condition', 'Other health condition'],
          ['health_none', 'None reported']
        ]);
        const priorityAreas = selected([
          ['priority_chest', 'Chest'],
          ['priority_shoulders', 'Shoulders'],
          ['priority_arms', 'Arms'],
          ['priority_back', 'Back'],
          ['priority_legs', 'Legs'],
          ['priority_glutes', 'Glutes'],
          ['priority_core', 'Core'],
          ['priority_overall', 'Overall']
        ]);
        const availableDays = selected([
          ['available_mon', 'Monday'],
          ['available_tue', 'Tuesday'],
          ['available_wed', 'Wednesday'],
          ['available_thu', 'Thursday'],
          ['available_fri', 'Friday'],
          ['available_sat', 'Saturday'],
          ['available_sun', 'Sunday']
        ]);
        const clearanceNotes = healthFlags && healthFlags !== 'None reported'
          ? [
              get('professional_clearance_status'),
              get('clearance_professional') && `Cleared by: ${get('clearance_professional')}`,
              get('clearance_date') && `Clearance date: ${get('clearance_date')}`,
              get('clearance_scope'),
              get('clearance_restrictions') && `Restrictions: ${get('clearance_restrictions')}`,
              get('current_symptoms')
            ].filter(Boolean).join('; ')
          : '';
        const healthNotes = [healthFlags, get('health_details'), clearanceNotes, get('medical_conditions_affecting_nutrition'), get('eating_disorder_or_difficult_relationship')]
          .filter(Boolean)
          .join(' | ');
        const consentConfirmed = get('adult_confirmation') === 'Yes'
          && get('service_scope_confirmation') === 'Yes'
          && get('health_data_consent') === 'Yes';

        return {
          answers: {
            'Order Number': get('order_number'),
            'Client Name': [get('first_name'), get('last_name')].filter(Boolean).join(' '),
            'Email': get('email'),
            'Age': get('age'),
            'Sex': get('sex_for_energy_estimate'),
            'Height': get('height_cm'),
            'Height Unit': 'cm',
            'Weight': get('weight_kg'),
            'Weight Unit': 'kg',
            'Occupation': get('occupation'),
            'Work Activity': get('work_activity'),
            'Primary Goal': get('primary_goal'),
            'Secondary Goal': get('secondary_goal'),
            'Target Weight / Physique': get('target_weight_or_physique'),
            'Areas to Improve': priorityAreas,
            'Target Timeframe': get('target_timeframe'),
            'Training Days / Week': get('training_days_per_week'),
            'Session Length': get('session_length'),
            'Available Days': availableDays,
            'Training Time': get('usual_training_time'),
            'Training Location': get('training_location'),
            'Equipment': get('equipment_access'),
            'Training Consistency': get('consistent_training_history'),
            'Current Routine': get('current_training_routine'),
            'Exercises Enjoyed': get('exercises_enjoyed'),
            'Exercises Disliked / Avoid': get('exercises_disliked'),
            'Priority Muscles': priorityAreas,
            'Exercises Requested': get('exercises_requested'),
            'Tracks Progression': get('tracks_progression'),
            'Strength Levels': get('approximate_strength_levels'),
            'Current Injuries / Pain': get('current_injuries_or_pain'),
            'Previous Injuries': get('previous_injuries'),
            'Advised Movements to Avoid': [get('movements_advised_to_avoid'), get('clearance_restrictions')].filter(Boolean).join(' | '),
            'Other Health Information': healthNotes,
            'Typical Diet': get('typical_day_of_eating'),
            'Current Meals / Day': get('current_meals_per_day'),
            'Tracks Calories': get('calorie_tracking'),
            'Current Calories': get('current_calories'),
            'Tracks Protein / Macros': get('protein_tracking'),
            'Current Protein': get('current_protein_g'),
            'Takeaways / Week': get('takeaways_per_week'),
            'Water / Day': get('daily_water'),
            'Caffeine / Day': get('daily_caffeine'),
            'Alcohol': get('alcohol_frequency'),
            'Foods to Keep': get('three_foods_or_meals_to_keep'),
            'Favourite Proteins': get('favourite_protein_sources'),
            'Favourite Carbs': get('favourite_carbohydrate_sources'),
            'Favourite Fruit': get('fruit_and_vegetables_enjoyed'),
            'Favourite Vegetables': get('fruit_and_vegetables_enjoyed'),
            'Healthy Fats': get('healthy_fat_sources_enjoyed'),
            'Foods Disliked': get('foods_disliked_or_excluded'),
            'Foods Excluded': get('foods_disliked_or_excluded'),
            'Allergies / Intolerances': get('allergies_intolerances_and_reactions'),
            'Dietary Style': get('diet_style'),
            'Cultural / Religious Restrictions': get('cultural_religious_personal_food_restrictions'),
            'Wake Time': get('usual_wake_time'),
            'Bed Time': get('usual_bed_time'),
            'Sleep Hours': get('average_sleep_hours'),
            'Sleep Quality': get('sleep_quality'),
            'Stress Level': get('stress_score_1_to_10'),
            'Steps / Day': get('average_daily_steps'),
            'Other Activity / Sports': get('other_sports_and_weekly_frequency'),
            'Travels Regularly': get('shift_work_travel_or_variable_schedule'),
            'Food Prep Time': get('daily_food_prep_time'),
            'Cooking Confidence': get('cooking_confidence'),
            'Kitchen at Work': get('work_kitchen_access'),
            'Food Budget': get('weekly_food_budget_gbp'),
            'Ideal Meals / Day': get('ideal_meals_per_day'),
            'Meal Size Preference': get('meal_size_preference'),
            'Breakfast Preference': get('breakfast_preference'),
            'Snacks Included': get('snacks_and_preworkout'),
            'Pre-Workout Meal': get('snacks_and_preworkout'),
            'Hardest Nutrition Challenge': get('biggest_nutrition_barrier'),
            'Hardest Training Challenge': get('biggest_training_barrier'),
            'Plan Style': get('preferred_plan_style'),
            'Adherence Confidence (1–10)': get('confidence_score_1_to_10'),
            'What Would Make It Easier': get('what_would_make_plan_easier'),
            'Current Supplements': get('current_supplements_and_doses'),
            'Supplement Doses': get('current_supplements_and_doses'),
            'Waist Measurement': get('waist_measurement_cm'),
            'Progress Photos': get('progress_photos_available'),
            'Weight Trend': get('recent_weight_trend'),
            'Consent / Accuracy': consentConfirmed ? 'Confirmed' : 'Needs clarification',
            'Coach Notes': [get('success_definition'), get('cardio_preferences'), get('minimum_sustainable_days'), get('anything_else')].filter(Boolean).join(' | ')
          }
        };
      }

      sendToTracker(data) {
        const endpoint = 'https://script.google.com/macros/s/AKfycbzUn_t8WrbnjkfACVxbJ_E93vy9vPAGaAFULTvJh-QMI-0j8MXvl2JSUMv-AzYPRCxeDg/exec';
        const body = JSON.stringify(this.buildTrackerPayload(data));
        const beaconBody = new Blob([body], { type: 'text/plain;charset=UTF-8' });
        const queued = navigator.sendBeacon && navigator.sendBeacon(endpoint, beaconBody);

        if (!queued) {
          fetch(endpoint, {
            method: 'POST',
            mode: 'no-cors',
            keepalive: true,
            headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
            body
          }).catch(() => {});
        }
      }

      handleSubmit(event) {
        if (!this.validatePanel(this.panels[this.current])) {
          event.preventDefault();
          return;
        }
        const data = new FormData(this.form);
        const lines = [];
        data.forEach((value, key) => {
          if (!key.includes('body') && !key.includes('form_type') && !key.includes('utf8')) {
            const label = key.replace('contact[', '').replace(']', '').replaceAll('_', ' ');
            lines.push(`${label}: ${value}`);
          }
        });
        this.summary.value = `FORGE FITNESS — PERSONALISED PROGRAMME INTAKE\n\n${lines.join('\n')}`;
        this.sendToTracker(data);
        const submit = this.querySelector('.forge-intake__submit');
        if (submit) {
          submit.disabled = true;
          submit.textContent = submit.dataset.loadingText;
        }
      }
    }

    if (!customElements.get('forge-intake')) customElements.define('forge-intake', ForgeIntake);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forge-weekly-check-in"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class ForgeWeeklyCheckIn extends HTMLElement {
      connectedCallback() {
        this.endpoint = 'https://script.google.com/macros/s/AKfycbzUn_t8WrbnjkfACVxbJ_E93vy9vPAGaAFULTvJh-QMI-0j8MXvl2JSUMv-AzYPRCxeDg/exec';
        this.form = this.querySelector('[data-form]');
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.current = 0;
        const params = new URLSearchParams(window.location.search);
        const clientId = (params.get('client') || '').trim();
        const token = (params.get('token') || '').trim();
        if (!clientId || !token) {
          this.querySelector('[data-link-error]').hidden = false;
          this.form.hidden = true;
          return;
        }
        this.form.elements.client_id.value = clientId;
        this.form.elements.token.value = token;
        this.querySelector('[data-client-label]').textContent = clientId;
        this.querySelectorAll('[data-next]').forEach(button => button.addEventListener('click', () => this.move(1)));
        this.querySelectorAll('[data-back]').forEach(button => button.addEventListener('click', () => this.move(-1)));
        this.querySelectorAll('input[type="range"]').forEach(input => {
          input.addEventListener('input', () => this.updateOutput(input));
          this.updateOutput(input);
        });
        this.form.elements.pain_status.forEach(input => input.addEventListener('change', () => this.togglePainDetails()));
        this.form.addEventListener('submit', event => this.submit(event));
        this.updateProgress();
      }

      updateOutput(input) {
        const output = this.querySelector(`[data-output-for="${input.name}"]`);
        if (output) output.textContent = input.name === 'nutrition_adherence' ? `${input.value}%` : input.value;
      }

      togglePainDetails() {
        const isNew = this.form.elements.pain_status.value === 'New or worsening pain/injury';
        const wrap = this.querySelector('[data-pain-details]');
        wrap.hidden = !isNew;
        wrap.querySelector('textarea').required = isNew;
      }

      validatePanel() {
        const fields = [...this.panels[this.current].querySelectorAll('input,textarea,select')].filter(field => !field.closest('[hidden]'));
        const invalid = fields.find(field => !field.checkValidity());
        if (invalid) {
          invalid.reportValidity();
          return false;
        }
        return true;
      }

      move(direction) {
        if (direction > 0 && !this.validatePanel()) return;
        this.panels[this.current].classList.remove('is-active');
        this.current = Math.max(0, Math.min(this.panels.length - 1, this.current + direction));
        this.panels[this.current].classList.add('is-active');
        this.updateProgress();
        window.scrollTo({ top: this.offsetTop, behavior: 'smooth' });
      }

      updateProgress() {
        const step = this.current + 1;
        this.querySelector('[data-progress-number]').textContent = `${step} / ${this.panels.length}`;
        this.querySelector('[data-progress-text]').textContent = this.panels[this.current].dataset.stepLabel;
        this.querySelector('[data-progress-bar]').style.width = `${step / this.panels.length * 100}%`;
      }

      submit(event) {
        event.preventDefault();
        if (!this.form.checkValidity()) {
          this.form.reportValidity();
          return;
        }
        const data = new FormData(this.form);
        const submissionId = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        const pain = data.get('pain_status') === 'New or worsening pain/injury'
          ? `New or worsening pain/injury: ${data.get('pain_details') || ''}`
          : 'No new pain or injury';
        const payload = {
          type: 'weekly_checkin',
          clientId: data.get('client_id'),
          token: data.get('token'),
          submissionId,
          answers: {
            'Body Weight': data.get('body_weight'),
            'Waist': data.get('waist'),
            'Average Steps': data.get('average_steps'),
            'Sleep Hours': data.get('sleep_hours'),
            'Nutrition Adherence %': data.get('nutrition_adherence'),
            'Training Sessions Completed': data.get('training_sessions'),
            'Training Performance': data.get('training_performance'),
            'Hunger (1–10)': data.get('hunger'),
            'Energy (1–10)': data.get('energy'),
            'Stress (1–10)': data.get('stress'),
            'Pain / Injury Update': pain,
            'Wins': data.get('wins'),
            'Obstacles': data.get('obstacles')
          }
        };
        const button = this.querySelector('[data-submit]');
        button.disabled = true;
        button.textContent = button.dataset.loading;
        fetch(this.endpoint, {
          method: 'POST',
          mode: 'no-cors',
          keepalive: true,
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify(payload)
        }).finally(() => {
          this.form.hidden = true;
          this.querySelector('.forge-checkin__progress').hidden = true;
          this.querySelector('[data-complete]').hidden = false;
          window.scrollTo({ top: this.offsetTop, behavior: 'smooth' });
        });
      }
    }
    if (!customElements.get('forge-weekly-check-in')) customElements.define('forge-weekly-check-in', ForgeWeeklyCheckIn);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
